module.exports = __webpack_public_path__ + "assets/icons/email-24px.svg";